module.exports = __webpack_public_path__ + "static/img/banner435.72b69f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner435.jpg
// module id = tkvS
// module chunks = 9